import { useAppSelector } from 'app/hooks';
import { equipmentPreferencesPageVisible } from 'utils/existing-equipment-page-visibility';

export default function useEquipmentPreferencesPageVisible() {
  const systemPreference = useAppSelector(
    (state) =>
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
  );
  return equipmentPreferencesPageVisible(systemPreference);
}
